import {

  CORE_LOAD_ALLBACKGROUND_REQUEST,
  CORE_LOAD_ALLBACKGROUND_SUCCESS,

  CORE_LOAD_BACKGROUNDINFO_REQUEST,
  CORE_LOAD_BACKGROUNDINFO_SUCCESS,

} from '../../types'

const initialState = []
export default {
  background: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLBACKGROUND_REQUEST:
        return initialState

      case CORE_LOAD_ALLBACKGROUND_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  backgroundInfo: (state = {}, action) => {
    switch (action.type) {
      case CORE_LOAD_BACKGROUNDINFO_REQUEST:
        return {}

      case CORE_LOAD_BACKGROUNDINFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/background/reducer.js